import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { formatString } from "@/core/utils/helpers";
import { GROUPS_API_PATH } from "../constants";
import type {
  GroupBookingPassengerUpdate,
  GroupBookingRequest,
  GroupPaymentOtpRequest,
  GroupPayNowRequest,
  GroupsListData,
} from "../types";

class GroupsService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public async fetchGroups(): Promise<ICoreResponse<GroupsListData>> {
    return this.restClient.get(GROUPS_API_PATH.LIST);
  }

  public async bookGroup(payload: GroupBookingRequest): Promise<ICoreResponse> {
    return this.restClient.post(GROUPS_API_PATH.BOOKING, payload);
  }

  public async fetchBookingDetail(bookingId: string): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(GROUPS_API_PATH.BOOKING_DETAIL, bookingId),
    );
  }

  public async updateBookingPassengers(
    bookingId: string,
    passengers: GroupBookingPassengerUpdate[],
  ): Promise<ICoreResponse> {
    return this.restClient.put(
      formatString(GROUPS_API_PATH.BOOKING_PASSENGERS, bookingId),
      { passengers },
    );
  }

  public async generatePaymentOtp(
    payload: GroupPaymentOtpRequest,
  ): Promise<ICoreResponse> {
    return this.restClient.post(GROUPS_API_PATH.PAYMENT_OTP, payload);
  }

  public async payNow(payload: GroupPayNowRequest): Promise<ICoreResponse> {
    return this.restClient.post(GROUPS_API_PATH.PAY_NOW, payload);
  }
}

export default GroupsService;
